import * as React from "react";
import CircularProgress from "@mui/material/CircularProgress";
import Box from "@mui/material/Box";
import { observer } from "mobx-react";
import { Typography } from "@mui/material";

export type ProcessingProps = {
  description?: string;
};

export const Processing: React.FC<ProcessingProps> = observer(
  ({ description }) => {
    return (
      <Box sx={{ display: "flex", marginLeft: 1 }}>
        <CircularProgress size={15} thickness={3} color="info" />
        <Typography sx={{ fontSize: 12, paddingLeft: 1 }}>
          {description}
        </Typography>
      </Box>
    );
  }
);
